
























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Debounce } from 'vue-debounce-decorator';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import VueQr from 'vue-qr';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'chatbot-documents-modal',
    data: function () {
        return {
            page_document_index: 1,
            page_document_start: 1,//pagina inicial
            document_per_page: 10,//Items per page
            documents_in_page: []
        };
    },
    components: {
        showFilesModal,
        Spinner,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('chatbotDocuments', ['activeChatbotDocumentLoading', 'activeChatbotDocument', 'page_document', 'activeChatbotDocument.sku_document']),
        ...mapState('chatbotDocuments', ['allChatbotDocumentLoading']),
        
    },

})
export default class ChatbotDocumentsModal extends Vue {
    //
    private currentUser!: any;
    public activeChatbotDocument!: any;
    public activeChatbotDocumentLoading!: boolean;
    public new_sku = '';
    public sku_validate = false;
    public document_per_page = 10;
    public total_document_pages!: any; 
    public file_type: any = '';
    public src: any = '';
    public document_title: any = '';
    public document_content: any = '';
    public document_content_JSON: any = '';
    public page_document_start !: any;
    public page_document_index = 1;
    public page_document!: any;
    public per_page = 1;
    public rows: any = '';
    public content: any = '';
    public documents_in_page !: any;
    public documents_before: any = '';
    public documents_after!: any;
    
    // public chatbotDocumentsPage_!: any;
    // public chatbotDocumentsPage!: any;

    mounted() {
        this.$root.$on('bv::modal::show', (bvEvent: any, modalId: string) => {
            if (modalId === 'chatbot-documents-modal') {
                // Inicializar primera página de documentos cuando se abre el modal
                this.inicializarDocumentos();
            }
        });
    }

    // Método para inicializar el arreglo de los documentos
    inicializarDocumentos() {
            if (this.activeChatbotDocument && this.activeChatbotDocument.sku_document) {
                const inicio = 0; // Comenzar desde el primer elemento
                const fin = this.document_per_page; // Mostrar primeros 10 elementos
                this.documents_in_page = this.activeChatbotDocument.sku_document.slice(inicio, fin);
                this.page_document_start = 1; // Establecer página actual en 1
            }
        }

    //Método para tener la cantidad total de páginas para un arreglo de un asistente
    titleDocumentPages(){
        this.total_document_pages = Math.ceil(this.activeChatbotDocument.sku_document.length/this.document_per_page)
        return this.total_document_pages;//El Math.ceil redondea al siguiente numero cuando hay decimal
    }

    //Métdo para dar los documentos en el número de página
    getDocumentsPerPage(page) {
        if (!this.activeChatbotDocument?.sku_document) return;
        
        const start = (page * this.document_per_page) - this.document_per_page;
        const end = page * this.document_per_page;
        this.documents_in_page = this.activeChatbotDocument.sku_document.slice(start, end);
    }

    //Este watch es para que cuando cambie de asistente se cambie
    @Watch('activeChatbotDocument')
    onActiveChatbotDocumentChange(newVal: any) {
        if (newVal && newVal.sku_document) {
            this.inicializarDocumentos();
        }
    }

    //Este método es para que se reinicie el arreglo del asistente cada que se cierre
    resetViewDocument(name) {
        this.content = '';
        this.document_title = '';
        this.hideModal(name);
    }

    

    setFileType(file_type: string) {
        this.file_type = file_type;
    }

    async onSaveChatbotDocument() {
        if (this.new_sku) {
            // console.log(this.activeChatbotDocument.sku_document[0]);
            if (!this.activeChatbotDocument.sku_document) {
                this.activeChatbotDocument.sku_document = [];
                this.activeChatbotDocument.id_document = 1;
            } else {
                if (this.activeChatbotDocument.sku_document.length == 0) this.activeChatbotDocument.id_document = 1;
                else {
                    let id = this.activeChatbotDocument.sku_document.length - 1;
                    this.activeChatbotDocument.id_document = this.activeChatbotDocument.sku_document[id].id + 1;
                    console.log(this.activeChatbotDocument.id_document);
                }
            }
            this.activeChatbotDocument.sku_document.push({
                id: this.activeChatbotDocument.id_document,
                sku: this.new_sku,
                name_document: this.activeChatbotDocument.document ? this.activeChatbotDocument.document.name : '',
            });
            this.documents_after = await this.$store.dispatch('chatbotDocuments/putOneDocument', {
                vm: this,
                data: this.activeChatbotDocument,
            });
            console.log(this.documents_after);
            console.log(this.activeChatbotDocument.document);
            
            
            this.activeChatbotDocument.sku_document.lenght = await this.Updatedocument();
            // console.log(this.activeChatbotDocument.sku_document.lenght);
            
            // this.documents_after = await this.$store.dispatch('chatbotDocuments/getOne', this.activeChatbotDocument.id);
            // this.activeChatbotDocument.sku_document = this.documents_after.sku_document;
            this.new_sku = '';
        } else {
            this.$bvToast.toast('Es necesario ingresar el campo "SKU del producto del nuevo documento"', {
                title: 'Falta Sku del Documento',
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }

    onCreateAssistant() {
        if (this.activeChatbotDocument.assistant_name && this.activeChatbotDocument.assistant_name.length >= 4) {
            if (/[!@#$%^&*(),.'?":{}|<>áéíóúüñÁÉÍÓÚÜÑ\s]/g.test(this.activeChatbotDocument.assistant_name)) {
                this.$bvToast.toast('Es necesario ingresar un nombre válido para el asistente (Sin caracteres especiales)', {
                    title: 'Nombre del Asistente inválido',
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            } else {
                const page = this.$route.query.page || 1;
                const search = this.$route.query.search || null;
                this.$store.dispatch('chatbotDocuments/postOne', {
                    vm: this,
                    data: this.activeChatbotDocument,
                });
                this.$store.dispatch('chatbotDocuments/getAll', {
                    page,
                    search,
                });
            }
        } else {
            this.$bvToast.toast('Es necesario ingresar un nombre válido para el asistente (mínimo cuatro caracteres)', {
                title: 'Nombre del Asistente inválido',
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }

    onOpenFilesModal(file_type: string) {
        this.file_type = file_type;
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    onDocumentChange(e: any) {
        if (this.file_type === 'featured') {
            if (e.target) {
                const file = e.target.files[0];
                const formData = new FormData();
                formData.append('pdf', file, file.name);

                this.activeChatbotDocument.document = {
                    id: uuidv4(),
                    sort: null,
                    url: URL.createObjectURL(file),
                    origin: 'upload',
                    file: formData,
                    name: file.name,
                };
            } else {
                this.activeChatbotDocument.document = {
                    id: e.id,
                    sort: null,
                    url: `https://directus.prodelec.app/assets/${e.id}`,
                    origin: 'directus-update',
                    file: '',
                    name: e.filename_download,
                };
            }
            this.file_type = '';
        }
    }

    onRemoveDocument() {
        this.activeChatbotDocument.document = null;
    }

    async onseeFile(index: number) {
        this.activeChatbotDocument.document_id = index;
        this.activeChatbotDocument.id_document = this.activeChatbotDocument.sku_document[index].id;
        this.$bvModal.show(`modalDocument${index}`);
        try {
            // Espera a que la promesa se resuelva
            this.document_content = await this.$store.dispatch('chatbotDocuments/getInfo', {
                vm: this,
                data: this.activeChatbotDocument,
            });
            this.document_title = this.activeChatbotDocument.sku_document[index].name_document;
            console.log(this.document_title);

            // Verifica si document_content ya es un objeto
            if (typeof this.document_content === 'string') {
                this.document_content_JSON = JSON.parse(this.document_content);
            } else {
                this.document_content_JSON = this.document_content;
            }
            const innerRawString = this.document_content_JSON.data.message;
            

            const cleanedString = innerRawString
                .replace(/'/g, '') // Eliminar las comillas simples adicionales
                .replace(/\\\\/g, '') // Reemplazar '\\\\' por '\\'
                .replace(/\\n/g, '');
            const jsonArray = JSON.parse(cleanedString);
            //console.log(jsonArray);
            // console.log('Mensaje1');
            console.log(cleanedString);
            console.log(jsonArray[0].page_content);
            this.document_content = jsonArray;
            this.rows = jsonArray.length;
            this.changeIndexPage(1);
            // return { currentPage: 1, items: this.document_content };
        } catch (error) {
            console.error('Error fetching document content:', error);
        }
    }

    hideModal(name: string) {
        this.$bvModal.hide(name);
    }
    DeleteDocument(id: any, assistant_document: any) {
        this.$bvModal
            .msgBoxConfirm(`¿Esta seguro que desea eliminar el documento ${assistant_document} asistente ?`, {
                title: 'Eliminar',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Eliminar',
                cancelTitle: 'Cancelar',
                footerClass: 'p-2',
            })
            .then(async (value: any) => {
                if (value) {
                    this.activeChatbotDocument.id_document = this.activeChatbotDocument.sku_document[id].id;
                    this.activeChatbotDocument.sku_document.splice(id, 1);
                    await this.$store.dispatch('chatbotDocuments/deleteOneDocument', { data: this.activeChatbotDocument, vm: this });
                }
            })
            .catch((err) => {
                // An error occurred
                console.log(err);
            });
    }

    async Updatedocument(){
        this.documents_after = await this.$store.dispatch('chatbotDocuments/UpdateDocumentJSON', this.activeChatbotDocument.id);
        this.activeChatbotDocument.sku_document = this.documents_after.sku_document;
        return this.activeChatbotDocument.sku_document;
    }

    changeIndexPage(current_page: any) {
        this.content = this.document_content[current_page-1].page_content;
        console.log(this.document_content[current_page-1].page_content);
        this.page_document_index = current_page
        // this.chatbotDocumentsPage_ = page;
    }

    canSee(roles: any) {
        let role_validation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        let userdId = '85c1e50c-01de-4365-991f-e6fd5d52d90a'; //development
        switch (this.currentUser.role.name) {
            case 'Admin':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                // if (this.currentUser.id != user1Id && this.currentUser.id != userdId) {
                //     role_validation = false;
                // }
                break;
            default:
                role_validation = false;
                break;
    }
    return role_validation;
    }
}
